module.exports = __webpack_public_path__ + "img/case10.7a441167.png";